import { memo } from 'react'
import { ImportDynamically } from './ImportDynamically'
import AsyncLocalStorage from '@createnextapp/async-local-storage'

const getValueFromConfig = (config) => {
  if (Object.hasOwn(config, 'reactAdmin')) {
    const { folder, file} = config.reactAdmin?.components.user.create
    return { folder, file }
  }
}

export const FieldsByApplication = memo((props) => {

  if (props.item.clients.checkedClient && props.item.applications.checkedApplication) {
    const configByApp = props.item.allApplicationToFilter?.find((elem) => (
      elem.application_id === props.item.applications.checkedApplication
    ))

    if (configByApp) {
      if (Object.entries(configByApp).length !== 0) {
        if (configByApp.application.config || configByApp.config) {
          // override Application config with ApplicationByClient config
          const config = { ...configByApp.application.config, ...configByApp.config }
          const data = getValueFromConfig(config)
          if (data) {
            ;(async () => {
              try {
                await AsyncLocalStorage.setItem('dataImport', JSON.stringify(data))
              } catch (e) {
              }
            })()

            return <ImportDynamically {...props}  />
          }
        }
      }
    }
  }
})
